import { getOrCreateAnonymousId, writeAnonymousIdCookie } from './anonymous-id';
import { mergeAttributionVisit, parseAttributionFromSearch } from './attribution';
import {
  ATTRIBUTION_KEY,
  FIRST_PV_FIRED_KEY,
  INITIAL_CAPTURED_KEY,
  INITIAL_REFERRER_KEY,
  INITIAL_URL_KEY,
  type StoredAttribution,
} from './constants';
import { ensureDataLayer } from './data-layer';
import { sanitizeAnalyticsHref } from './sanitize-location';

export const bootstrapAttribution = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  ensureDataLayer();

  const anonymousId = getOrCreateAnonymousId();
  writeAnonymousIdCookie(anonymousId);
  window.dataLayer.push({ anonymous_id: anonymousId });

  const pageHref = sanitizeAnalyticsHref(window.location.href);

  if (!sessionStorage.getItem(INITIAL_CAPTURED_KEY)) {
    localStorage.setItem(INITIAL_URL_KEY, pageHref);
    localStorage.setItem(INITIAL_REFERRER_KEY, document.referrer || '');
    sessionStorage.setItem(INITIAL_CAPTURED_KEY, '1');
  }

  sessionStorage.removeItem(FIRST_PV_FIRED_KEY);

  const attributionParams = parseAttributionFromSearch(window.location.search);
  const storedRaw = localStorage.getItem(ATTRIBUTION_KEY);
  const stored: StoredAttribution = storedRaw ? JSON.parse(storedRaw) : {};
  const merged = mergeAttributionVisit(
    stored,
    attributionParams,
    pageHref,
    document.referrer || '',
    Date.now(),
  );

  if (JSON.stringify(merged) !== JSON.stringify(stored)) {
    localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(merged));
  }

  return anonymousId;
};
